{
  "slug": "what-does-an-iq-of-140-mean",
  "title": "What does an IQ of 140 mean?",
  "description": "Understand the approximate percentile of a 140 IQ score, testing at the extreme, and why context still matters.",
  "summary": "On a scale with a mean of 100 and standard deviation of 15, 140 is about 2.67 standard deviations above the mean and near the 99.6th percentile.",
  "sections": [
    {
      "heading": "A rare score",
      "paragraphs": [
        "A percentile near 99.6 suggests performance higher than roughly 996 people out of 1,000 in the reference group. The exact conversion depends on the instrument and its norms.",
        "Scores at the extreme are less precise because norm samples contain fewer people at that level. Test ceilings can also limit how well very high ability is differentiated."
      ]
    },
    {
      "heading": "How professionals interpret it",
      "paragraphs": [
        "A professional checks the confidence interval, subtest consistency, validity indicators, and whether the test suited the person’s age and language. Institutional thresholds are not universal.",
        "A broad battery can distinguish verbal, spatial, memory, and processing skills more clearly than a short online test."
      ]
    },
    {
      "heading": "High IQ is not the whole story",
      "paragraphs": [
        "A very high score can indicate exceptional performance on tested abilities, but it does not automatically translate into achievement or wellbeing. Motivation, support, creativity, context, and opportunity influence outcomes.",
        "Online estimates near an extreme should be treated particularly cautiously and confirmed professionally when a formal decision depends on them."
      ]
    }
  ],
  "faqs": [
    {
      "question": "How rare is an IQ of 140?",
      "answer": "It is approximately in the top 0.4% on a normal distribution with a mean of 100 and standard deviation of 15."
    },
    {
      "question": "Is an online score of 140 official?",
      "answer": "No. Formal conclusions require a suitably normed test administered and interpreted by a qualified professional."
    }
  ],
  "related": ["iq-score-ranges-explained", "what-does-an-iq-of-120-mean", "iq-vs-intelligence"]
}
